module.exports = __webpack_public_path__ + "static/media/bipc.a054631e.webp";